import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  Icon,
  Text,
  Stack,
  VStack,
  Flex
} from '@chakra-ui/react';
import { BiNetworkChart } from 'react-icons/bi';
import { RiHandCoinLine, RiCoinLine } from 'react-icons/ri';
import { TbCoinOff } from 'react-icons/tb';
import { GrCycle } from 'react-icons/gr';
import { MdControlPointDuplicate } from 'react-icons/md';
import { AiOutlineCopyrightCircle } from 'react-icons/ai';
import { GiShrimp } from 'react-icons/gi';

const features = [
  {
    id: 0,
    icon: TbCoinOff,
    title: '0% Interest Rate',
    text: 'Crangon charges a small, one-time fee to borrow CUSD instead of highly variable interest rates.'
  },{
    id: 1,
    icon: RiHandCoinLine,
    title: '110% Collateral Ratio*',
    text: 'Crangon\'s efficient liquidation mechanism allows users to get the most liquidity for their BNB. *Under normal operation.'
  },{
    id: 2,
    icon: BiNetworkChart,
    title: 'Fully Decentralized',
    text: 'CUSD is a decentralized stablecoin capable of resisting all kinds of censorship. Even founding team has no control over the protocol.'
  },{
    id: 3,
    icon: RiCoinLine,
    title: 'Trove Requirement 100 CUSD',
    text: 'Super low threshold making it effortless to interact with the protocol and maximizing the liquidity.'
  },{
    id: 4,
    icon: GrCycle,
    title: 'Efficient Liquidations',
    text: 'Crangon\'s quick and efficient liquidations of Troves maintain the health and stability of the protocol.'
  },{
    id: 5,
    icon: MdControlPointDuplicate,
    title: 'Redeemable Stablecoin',
    text: 'CUSD is a fully redeemable stablecoin. At any time, the protocol allows holders to redeem their CUSD for the underlying BNB collateral at face value.'
  },{
    id: 6,
    icon: AiOutlineCopyrightCircle,
    title: 'Incentives for Stability Providers',
    text: 'Users can deposit CUSD tokens to the Stability Pool and receive liquidation gains and CGN rewards'
  },{
    id: 7,
    icon: GiShrimp,
    title: 'Incentives for CGN Stakers',
    text: 'Crangon captures the revenue from the borrowing and redemption fees and pays it out on a pro rata basis to the stakers of the CGN token.'
  }
]

export default function GridListWithHeading() {
  return (
    <Box p={4} bg='yellow.100' py='20'>
      <Stack spacing={4} as={Container} maxW={'3xl'} textAlign={'center'}>
        <Heading fontSize={'5xl'} color='black'>Features</Heading>
        <Text color={'gray.600'} fontSize={'2xl'}>
          Crangon is a decentralized borrowing protocol that offers unprecedented benefits for borrowers.
        </Text>
      </Stack>

      <Container maxW={'6xl'} mt={10}>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={10}>
          {features.map((feature) => (
            <VStack align={'start'}>
              <Flex
                w={16}
                h={16}
                align={'center'}
                justify={'center'}
                color={'black'}
                rounded={'full'}
                bg={'yellow.300'}
                mb={1}>
                <Icon as={feature.icon} w={10} h={10}/>
              </Flex>
              <Text fontWeight={600} color='black'>{feature.title}</Text>
              <Text color={'gray.600'}>{feature.text}</Text>
            </VStack>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
